// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"85":"bb10ca082147b40e","282":"f097c395406508b9","770":"2d62c98bd9c593b6"}[chunkId] + ".js";
};